import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import SearchTypeToggle from 'shared/components/search-type-toggle/search-type-toggle'
import { connect } from 'react-redux'
import { fetchGifsFromUrl } from 'shared/redux/fetch-gifs'
import * as selectors from 'shared/redux/reducers'
import { searchType } from 'shared/redux/search-type-toggle'
import { removeWords } from '../util/string'

export default connect(
    state => ({ searchType: selectors.getSearchType(state) }),
    dispatch => ({
        toggleSearchType: currentSearchType => {
            const path = removeWords(document.location.pathname, ['-sticker', '-stickers', '-transparent'])
            if (currentSearchType === 'sticker') {
                dispatch(searchType('gif'))
                dispatch(fetchGifsFromUrl(`${path}${document.location.search}`, { groupId: path }))
            } else {
                dispatch(searchType('sticker'))
                dispatch(
                    fetchGifsFromUrl(`${path}-stickers${document.location.search}`, { groupId: `${path}-stickers` }),
                )
            }
        },
    }),
)(SearchTypeToggle)

// TODO update desktop
// Trying to simplify groupId messiness using pathnames and route matching
export const MobileSearchTypeToggle = connect(state => ({ searchType: selectors.getSearchType(state) }), {
    setSearchType: searchType,
    fetchGifsFromUrl,
})(SearchTypeToggle)
